module.exports = __webpack_public_path__ + "media/coffee-preferences/main_flavor_fruity-9daf74f6.png";